import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BoatOwner } from 'anchor-shared/lib/model/entity/boatOwner';
import { BoatOwnerDAO } from '../../../../core/services/dao/boatOwnerDAO';
import { ApproveRejectButtonComponent } from '../../../shared/listGrid/approveRejectButton/approve-reject-button.component';
import { ListGridComponent } from '../../../shared/listGrid/listGrid.component';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-boat-owner',
  templateUrl: './boat-owner.component.html',
  styleUrls: ['./boat-owner.component.scss'],
})
export class BoatOwnerComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];
  boatOwners: BoatOwner[];
  columnDefs;
  rowData;
  editPath;

  @ViewChild(ListGridComponent)
  grid: ListGridComponent;

  constructor(
    private route: ActivatedRoute,
    private boatOwnerDao: BoatOwnerDAO,
  ) {
    this.editPath = 'manage/admin/user/edit';
    const dataSub = this.route.data.subscribe((data) => {
      this.boatOwners = data.portal.boatOwnerResolve;
      this.columnDefs = this.createColumnDefs();
    });
    this.subs.push(dataSub);
  }

  ngOnInit() {}

  private createColumnDefs() {
    return [
      {
        headerName: 'Id',
        field: 'id',
        filter: 'text',
        maxWidth: 50,
      },
      {
        headerName: 'Email',
        field: 'user.email',
        filter: 'text',
      },
      {
        headerName: 'First Name',
        field: 'user.firstName',
        filter: 'text',
      },
      {
        headerName: 'Last Name',
        field: 'user.lastName',
        filter: 'text',
      },
      {
        headerName: 'Phone Number',
        field: 'user.phoneNumber',
        filter: 'text',
      },
      {
        headerName: 'Stripe ID',
        field: 'user.userPaymentDetails.stripeUserId',
        filter: 'text',
      },
      {
        headerName: 'Status',
        suppressMenu: true,
        cellRendererFramework: ApproveRejectButtonComponent,
        suppressSizeToFit: true,
        width: 50,
      },
    ];
  }

  public onAction(data: any) {
    if (data.type === 'activateDeactivate') {
      this.onApproveRejectClick(data.data);
    } else {
      throw new Error('list grid emitted unsupported action');
    }
  }

  private createRowData(): any {
    const boatSub = this.boatOwnerDao.get().subscribe((boatOwner) => {
      return boatOwner;
    });
    this.subs.push(boatSub);
  }

  private onApproveRejectClick(data: BoatOwner): void {
    data.approved = !data.approved;
    this.boatOwnerDao.serverUpdate(data).subscribe(
      () => {
        if (data.approved) {
          this.boatOwnerDao.sendApprovalEmail(data.id).subscribe(() => {
            this.grid.gridOptions.api.setRowData(this.createRowData());
          });
        } else {
          this.grid.gridOptions.api.setRowData(this.createRowData());
        }
      },
      (err) => console.error(err),
    );
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }
}
